import moment from 'moment'

export const dateFilter = (value) => {
  return moment(value).format('DD-MM-YYYY HH:mm:ss')
}
